module.exports = __webpack_public_path__ + "assets/message-30d9fc.svg";